var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { unwrapWebsiteBuilderApiData } from "./response";
const GET_SET_WEBSITE_BUILDER = "api/website-builder/settings";
export const updateSettings = function (payload) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const response = yield this.axiosInstance.put(GET_SET_WEBSITE_BUILDER, payload, config);
            return unwrapWebsiteBuilderApiData(response);
        }
        catch (error) {
            console.error("Error updating Website Builder settings:", error);
            throw error;
        }
    });
};
